import React from "react";
import { Link } from "react-router-dom";
import "./style.css";
import Logout from "../Logout/Logout";
import userIcon from "../../assets/user-icon.png";

function ContentHeaderUi({
  title,
  buttonName,
  buttonBoolean,
  pageName,
  linkPath,
  onBack,
  backButton,
  decodedToken,
  logOut,
}) {
  
  return (
    <section className="content-header">
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-6 d-flex align-items-center">
            <div className="d-flex align-items-center">
              {backButton && (
                <h4 className="mb-0">
                  <i
                    class="fas fa-arrow-left mr-3 cursor-pointer"
                    onClick={onBack}
                  ></i>
                </h4>
              )}
              <h1>{title}</h1>
            </div>
          </div>
          <div className="col-sm-6">
            {buttonBoolean ? (
              buttonName ? (
                <ol className="breadcrumb float-sm-right mt-1">
                  {/* {linkPath == "/master-data/create-rrb" ? (
                    <button
                      data-toggle="modal"
                      data-target="#modal-default"
                      className="btn btn-primary"
                    >
                      {buttonName}
                    </button>
                  ) : (
                    <Link to={linkPath}>
                      <button className="btn btn-primary">{buttonName}</button>
                    </Link>
                  )} */}
                  <Link to={linkPath}>
                    <button className="blue-btn">{buttonName}</button>
                  </Link>
                </ol>
              ) : (
                ""
              )
            ) : (
              // <ol className="breadcrumb float-sm-right">
              //   <li className="breadcrumb-item">
              //     <Link to="/">Home</Link>
              //   </li>
              //   <li className="breadcrumb-item active">{pageName}</li>
              // </ol>
              ""
            )}
            {/* {decodedToken ? ( */}
            {buttonBoolean ?
          null  
          :
          <div className="d-flex justify-content-end align-items-center">
          {/* <p className="username"><i class="fas fa-user-circle"></i> {decodedToken?.firstname} {decodedToken?.lastname}</p> */}
          <div className="dropdown">
            <button
              className="btn  dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              // data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              style={{border:'none', padding:'0px', display:'flex', alignItems:'center'}}
            >
              <div className="dropdown-profile-conatiner">
                  <img src={userIcon} alt="icon" />
              </div>
              <div className="user-data">
                <p className="mb-0 user-name">{decodedToken?.firstname} {decodedToken?.lastname}</p>
                <p className="mb-0 user-phone-number">{decodedToken?.phone_number}</p>
              </div>
            </button>
            <div
              className="dropdown-menu dropdown-menu-container-profile"
              aria-labelledby="dropdownMenuButton"
            >
              <p className="username">
             {decodedToken?.firstname} &nbsp;
                {decodedToken?.lastname}
              </p>

              <a className="dropdown-item " href="#">
                <i className="fas fa-user"></i>
                <span className="ml-3"> Profile</span>
              </a>
              <a
                className="dropdown-item "
                data-toggle="modal"
                data-target="#modal-danger-logout"
                style={{paddingTop:'0px'}}
              >
                <i className="fas fa-sign-out-alt"></i>{" "}
                <span className="ml-3"> Log Out</span>
              </a>
            </div>
          </div>
        </div>
          }
             
            {/* ) : null} */}
          </div>
        </div>
      </div>
      <Logout logOut={logOut} />
    </section>
  );
}

export default ContentHeaderUi;
